import React, { useState } from "react";
import { If } from "react-condition";
import { useHistory, Link } from "react-router-dom";
import { useEffect } from "react";
import logo from "../images/Maxicus_logo.png";
import { DOMAIN,kochartechLogo } from "../umConfig"

function NavbarApplication() {
  const history = useHistory();
  const [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    if (
      localStorage.getItem("candidate.token") !== null &&
      localStorage.getItem("candidate.name") !== null &&
      localStorage.getItem("candidate.email") !== null &&
      localStorage.getItem("candidate.id") !== null
    ) {
      setLoggedIn(true);
    }
  }, []);

  function onClickLogout(event) {
    event.preventDefault();
    localStorage.removeItem("candidate.name");
    localStorage.removeItem("candidate.token");
    localStorage.removeItem("candidate.email");
    localStorage.removeItem("candidate.id");
    history.push("/careers");
  }

  return (
    <nav className="navbar navbar-expand navbar-light bg-white topbar  mt-0 static-top shadow sticky-top">
      <div className="container-fluid">
        <ul className="navbar-nav">
          <li className="nav-item">
            <a
              className="nav-link nav-link-black nav-link-bold nav-brand"
              href="#/"
            >
              {
                window.location.hostname === DOMAIN ?
                <img src={kochartechLogo} alt="" /> : <img src={logo} alt="" />
              }
            </a>
          </li> 
        </ul>

        <ul className="navbar-nav ml-auto">
          <If test={loggedIn}>
            <li className="nav-item">
              <Link to="/careers/home" className="nav-link nav-link-black">
                {/* Application Status */}
              </Link>
            </li>
          </If>

          {/* <li className="nav-item">
            <a className="nav-link nav-link-black" href="#/">
              Our Company
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link nav-link-black" href="#/">
              Meet Our Team
            </a>
          </li> */}
          <If test={loggedIn}>
            <li className="nav-item">
              <a
                href="#/"
                className="nav-link nav-link-black"
                onClick={onClickLogout}
              >
                Logout
              </a>
            </li>
          </If>
        </ul>
      </div>
    </nav>
  );
}

export default NavbarApplication;
